import AbstractWidgetNotification from './YPAbstractWidgetNotificationObject';

export default class TimesheetNotification extends AbstractWidgetNotification {
  isTimesheetNotification() {
    return true;
  }

  getPath() {
    return 'timesheetNotifications';
  }

  getNotifications(rosterNotifications, updateNotifications, timesheetNotifications) {
    return timesheetNotifications;
  }
}
